module.exports = __webpack_public_path__ + "img/1893.e3833663.svg";